//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'OxygenTankRemainingTime',
  data () {
    return {
      defaultJson: {
        "Tank Volume": "容器体积",
        "M Cylinder": "M 瓶",
        "G Cylinder": "G 瓶",
        "H Cylinder": "H\/K 瓶",
        "Tank Pressure": "容器压力",
        "Cylinder size \/ Tank factor": "氧气瓶大小 \/ 转换因子",
        "D Cylinder": "D 瓶",
        "E Cylinder": "E 瓶",
        "Remaining Time": "剩余时间",
        "Tanks Needed": "所需氧气瓶数量",
        "Transfer Duration": "持续时间",
        "Flow Rate": "流量",
        "Residual Pressure": "残余压力"
      },
      form: {
        flow:'',
        tankpress:'',
        volume:'',
        tankfactor:'',
        respress:'200',
        // transporttime:'',
      },
      transporttime:'',
      hasScore: false,
      disabled: false,
      descTxt:'',
      dummy:'bar',
      dataList1: [
        {value: '0.16', name: 'D 瓶'},
        {value: '0.28', name: 'E 瓶'},
        {value: '2.41', name: 'G 瓶'},
        {value: '3.14', name: 'H 瓶'},
        {value: '1.56', name: 'M 瓶'},
      ],
      barRes:'',
      psiRes:'',
      res2:'--',
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    setUnitsValueName(data){
      let self = this
      console.log(data)
      self.dummy = data.key
    },
    /** 计算热 res2 */
    calculationRes2(result, transporttime){
      console.log(result, transporttime,'result, transporttime')
      let self = this
       console.log('transporttime--5')
      if (transporttime &&transporttime!='---' && result && result !=='--') {
        let currentTransporttime =Number(transporttime)
        let currentresult =Number(result)
        let res = Math.ceil(currentTransporttime*60/currentresult)
        self.res2 = String(res)
        console.log('transporttime--7')
      } else {
        console.log('transporttime--6')
        self.res2 ='--'
      }

    }
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (self.dummy !='psi') {
        form.tankfactor='0'
        form.respress='0'
      } else {
        form.volume='0'
      }
      
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        self.calculationRes2('--', self.transporttime)
        return '--'
      } else {
        console.log(form)
        // g + p + r  form.
        // tankpress * volume / flow	
        let barRes = form.tankpress * form.volume / form.flow	
        // ((tankpress / 0.0689476) > respress) ? ((tankpress / 0.0689476 - respress) * tankfactor / flow) : nil
        let psiRes = ((form.tankpress / 0.0689476) > form.respress) ? ((form.tankpress / 0.0689476 - form.respress) * form.tankfactor / form.flow) : '--'

        // (tankpress.activeUnit != dummy.activeUnit) ? barRes : psiRes

        let result = self.dummy !='psi'? barRes : psiRes
        console.log('transporttime--6',result)
        self.calculationRes2(result, self.transporttime)
        
        self.hasScore = true
        return String(result.toFixed(0))
      }
    },
  },
  watch: {
    transporttime(newValue, oldValue) {
      let self = this
      self.calculationRes2(self.score, newValue)
    }
  },

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/OxygenTankRemainingTime.vue